// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__2WydV","footer":"ModalError_footer__33MC7"};